import { AnalyticsIntelPayload, SessionIdProvider } from "./analytics-service.model";

export class AnalyticsService {
  private sessionIdProvider: SessionIdProvider;

  constructor(sessionIdProvider: SessionIdProvider) {
    this.sessionIdProvider = sessionIdProvider;
  }

  // Dispatch an analytics event for events generated by front-end activity.
  dispatchFrontEndAnalytics(name: string): void {
    const intel: AnalyticsIntelPayload = {
      name: 'in_page_interaction',
      in_page: {
        name,
        category: 'link_button_click',
        location: 'chatbot'
      },
    };
    this.dispatchAnalytics(intel);
  }

  dispatchAnalytics(intel: AnalyticsIntelPayload): void {
    const payload = {
      detail: {
        sessionId: this.sessionIdProvider(),
        ...intel
      }
    }

    document.body.dispatchEvent(new CustomEvent<object>('postnl-datalayer-event', payload));
  };
}
